import { useEffect, useState } from 'react';
import { GoogleConsts } from './google-consts';

export const useGoogleLibraries = (enabled: boolean = true) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    };

    Promise.all([
      loadScript(GoogleConsts.GSI_CLIENT_URL), 
      loadScript(GoogleConsts.API_URL),
    ])
      .then(() => {
        // Inicjalizujemy Pickera wewnątrz GAPI
        window.gapi.load('picker', () => setLoaded(true));
      })
      .catch((err) => console.error('Błąd ładowania bibliotek Google', err));
  }, [enabled]);

  return loaded;
};